import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  activeInactiveDegree,
  createDegree,
  deleteDegree,
  getAllActiveDegree,
  getAllDegree,
  getDegreeByID,
  updateDegree,
} from "./services/degree.services";

export interface IDegreeState {
  loading: boolean;
  formloading: boolean;
  error: string;
  DegreeID: number | null;
  DegreeList: IDegree[];
  DegreeDetail: IDegreeDetails;
}

export interface IDegreeDetails {
  ID?: number | null;
  Title: string;
  IsActive: number | boolean;
}

export interface IDegree {
  ID: number;
  Title: string;
  IsActive: number | boolean;
}

const initialState: IDegreeState = {
  loading: false,
  formloading: false,
  error: "",
  DegreeID: null,
  DegreeList: [],
  DegreeDetail: {
    Title: "",
    IsActive: 1,
  },
};

const degreeSlice = createSlice({
  name: "degree",
  initialState,
  reducers: {
    clearDegreeDetails: (state) => {
      state.DegreeDetail = initialState.DegreeDetail;
    },
    setDegreeID: (state, action: PayloadAction<number>) => {
      state.DegreeID = action.payload;
    },
    clearDegreeID: (state) => {
      state.DegreeID = initialState.DegreeID;
    },
  },
  extraReducers: (builder) => {
    // GetAllDegree
    builder.addCase(getAllDegree.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllDegree.fulfilled,
      (state, action: PayloadAction<IDegree[]>) => {
        state.loading = false;
        state.DegreeList = action.payload || [];
      },
    );
    builder.addCase(getAllDegree.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DegreeList = [];
    });

    // CreateDegree
    builder.addCase(createDegree.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createDegree.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createDegree.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // UpdateDegree
    builder.addCase(updateDegree.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateDegree.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateDegree.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // DeleteDegree
    builder.addCase(deleteDegree.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDegree.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDegree.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // GetDegreeByID
    builder.addCase(getDegreeByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(
      getDegreeByID.fulfilled,
      (state, action: PayloadAction<IDegree>) => {
        state.formloading = false;
        state.DegreeDetail = action.payload;
      },
    );
    builder.addCase(getDegreeByID.rejected, (state, action) => {
      state.formloading = false;
      state.DegreeDetail = initialState.DegreeDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // GetAllActiveDegree
    builder.addCase(getAllActiveDegree.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveDegree.fulfilled,
      (state, action: PayloadAction<IDegree[]>) => {
        state.loading = false;
        state.DegreeList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveDegree.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DegreeList = [];
    });

    // ActiveInactiveDegree
    builder.addCase(activeInactiveDegree.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveDegree.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveDegree.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearDegreeDetails, clearDegreeID, setDegreeID } =
  degreeSlice.actions;
export default degreeSlice.reducer;
